// Generate Hash
const seen = new WeakSet();

export function hash(value: any): string {
  return window.btoa(
    unescape(
      encodeURIComponent(
        JSON.stringify(value, (_, value) => {
          if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) return;
            seen.add(value);
          }
          return value;
        }),
      ),
    ),
  );
}
